"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SuperfluidMock__factory = void 0;
/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */
const ethers_1 = require("ethers");
const _abi = [
    {
        inputs: [
            {
                internalType: "bool",
                name: "nonUpgradable",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "appWhiteListingEnabled",
                type: "bool",
            },
        ],
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "_code",
                type: "uint256",
            },
        ],
        name: "APP_RULE",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_ALREADY_REGISTERED",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_CALLBACK_IS_NOT_ACTION",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_AGREEMENT_IS_NOT_REGISTERED",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_CALL_AGREEMENT_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_CALL_APP_ACTION_WITH_CTX_FROM_WRONG_ADDRESS",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_CANNOT_DOWNGRADE_TO_NON_UPGRADEABLE",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_INVALID_CONFIG_WORD",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_INVALID_OR_EXPIRED_SUPER_APP_REGISTRATION_KEY",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_MAX_256_AGREEMENTS",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_MUST_BE_CONTRACT",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_NON_UPGRADEABLE",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_NON_ZERO_LENGTH_PLACEHOLDER_CTX",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_NOT_A_SUPER_APP",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_NO_APP_REGISTRATION_PERMISSIONS",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_ONLY_GOVERNANCE",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_ONLY_LISTED_AGREEMENT",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_RECEIVER_IS_NOT_SUPER_APP",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_SENDER_IS_NOT_SUPER_APP",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_SOURCE_APP_NEEDS_HIGHER_APP_LEVEL",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_ALREADY_REGISTERED",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_SUPER_APP_IS_JAILED",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_UNAUTHORIZED_SUPER_APP_FACTORY",
        type: "error",
    },
    {
        inputs: [],
        name: "HOST_UNKNOWN_BATCH_CALL_OPERATION_TYPE",
        type: "error",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address",
            },
        ],
        name: "AgreementClassRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address",
            },
        ],
        name: "AgreementClassUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
        ],
        name: "AppRegistered",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "bytes32",
                name: "uuid",
                type: "bytes32",
            },
            {
                indexed: false,
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        name: "CodeUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "oldGov",
                type: "address",
            },
            {
                indexed: false,
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address",
            },
        ],
        name: "GovernanceReplaced",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "uint8",
                name: "version",
                type: "uint8",
            },
        ],
        name: "Initialized",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                indexed: false,
                internalType: "uint256",
                name: "reason",
                type: "uint256",
            },
        ],
        name: "Jail",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address",
            },
        ],
        name: "SuperTokenFactoryUpdated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
            {
                indexed: false,
                internalType: "address",
                name: "code",
                type: "address",
            },
        ],
        name: "SuperTokenLogicUpdated",
        type: "event",
    },
    {
        inputs: [],
        name: "APP_WHITE_LISTING_ENABLED",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "CALLBACK_GAS_LIMIT",
        outputs: [
            {
                internalType: "uint64",
                name: "",
                type: "uint64",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "NON_UPGRADABLE_DEPLOYMENT",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32",
            },
        ],
        name: "addToAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address",
            },
        ],
        name: "allowCompositeApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
            {
                internalType: "int256",
                name: "appCreditUsedDelta",
                type: "int256",
            },
        ],
        name: "appCallbackPop",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "appCreditGranted",
                type: "uint256",
            },
            {
                internalType: "int256",
                name: "appCreditUsed",
                type: "int256",
            },
            {
                internalType: "contract ISuperfluidToken",
                name: "appCreditToken",
                type: "address",
            },
        ],
        name: "appCallbackPush",
        outputs: [
            {
                internalType: "bytes",
                name: "appCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]",
            },
        ],
        name: "batchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
        ],
        name: "callAgreement",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "userData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "callAgreementWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
        ],
        name: "callAppAction",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "callAppActionWithContext",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "callAppAfterCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "bytes",
                name: "callData",
                type: "bytes",
            },
            {
                internalType: "bool",
                name: "isTermination",
                type: "bool",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "callAppBeforeCallback",
        outputs: [
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "castrate",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "n",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "ctxFunc1",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "superToken",
                type: "address",
            },
            {
                internalType: "address",
                name: "agreementClass",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "agreementId",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "agreementData",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "cbdata",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "ctxFunc2",
        outputs: [
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "address",
                name: "",
                type: "address",
            },
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "",
                type: "bytes",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
            {
                internalType: "int256",
                name: "appCreditUsedMore",
                type: "int256",
            },
        ],
        name: "ctxUseCredit",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "decodeCtx",
        outputs: [
            {
                components: [
                    {
                        internalType: "uint8",
                        name: "appCallbackLevel",
                        type: "uint8",
                    },
                    {
                        internalType: "uint8",
                        name: "callType",
                        type: "uint8",
                    },
                    {
                        internalType: "uint256",
                        name: "timestamp",
                        type: "uint256",
                    },
                    {
                        internalType: "address",
                        name: "msgSender",
                        type: "address",
                    },
                    {
                        internalType: "bytes4",
                        name: "agreementSelector",
                        type: "bytes4",
                    },
                    {
                        internalType: "bytes",
                        name: "userData",
                        type: "bytes",
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditGranted",
                        type: "uint256",
                    },
                    {
                        internalType: "uint256",
                        name: "appCreditWantedDeprecated",
                        type: "uint256",
                    },
                    {
                        internalType: "int256",
                        name: "appCreditUsed",
                        type: "int256",
                    },
                    {
                        internalType: "address",
                        name: "appAddress",
                        type: "address",
                    },
                    {
                        internalType: "contract ISuperfluidToken",
                        name: "appCreditToken",
                        type: "address",
                    },
                ],
                internalType: "struct ISuperfluid.Context",
                name: "context",
                type: "tuple",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                components: [
                    {
                        internalType: "uint32",
                        name: "operationType",
                        type: "uint32",
                    },
                    {
                        internalType: "address",
                        name: "target",
                        type: "address",
                    },
                    {
                        internalType: "bytes",
                        name: "data",
                        type: "bytes",
                    },
                ],
                internalType: "struct ISuperfluid.Operation[]",
                name: "operations",
                type: "tuple[]",
            },
        ],
        name: "forwardBatchCall",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32",
            },
        ],
        name: "getAgreementClass",
        outputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "appAddr",
                type: "address",
            },
        ],
        name: "getAppCallbackLevel",
        outputs: [
            {
                internalType: "uint8",
                name: "",
                type: "uint8",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
        ],
        name: "getAppManifest",
        outputs: [
            {
                internalType: "bool",
                name: "isSuperApp",
                type: "bool",
            },
            {
                internalType: "bool",
                name: "isJailed",
                type: "bool",
            },
            {
                internalType: "uint256",
                name: "noopMask",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getCodeAddress",
        outputs: [
            {
                internalType: "address",
                name: "codeAddress",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getGovernance",
        outputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getNow",
        outputs: [
            {
                internalType: "uint256",
                name: "",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSuperTokenFactory",
        outputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "factory",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "getSuperTokenFactoryLogic",
        outputs: [
            {
                internalType: "address",
                name: "logic",
                type: "address",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "gov",
                type: "address",
            },
        ],
        name: "initialize",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClass",
                type: "address",
            },
        ],
        name: "isAgreementClassListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32",
            },
        ],
        name: "isAgreementTypeListed",
        outputs: [
            {
                internalType: "bool",
                name: "yes",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
        ],
        name: "isApp",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
        ],
        name: "isAppJailed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "contract ISuperApp",
                name: "targetApp",
                type: "address",
            },
        ],
        name: "isCompositeAppAllowed",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "isCtxValid",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "forwarder",
                type: "address",
            },
        ],
        name: "isTrustedForwarder",
        outputs: [
            {
                internalType: "bool",
                name: "",
                type: "bool",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
        ],
        name: "jailApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "reason",
                type: "uint256",
            },
        ],
        name: "jailApp",
        outputs: [
            {
                internalType: "bytes",
                name: "newCtx",
                type: "bytes",
            },
        ],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256",
            },
        ],
        name: "mapAgreementClasses",
        outputs: [
            {
                internalType: "contract ISuperAgreement[]",
                name: "agreementClasses",
                type: "address[]",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [],
        name: "proxiableUUID",
        outputs: [
            {
                internalType: "bytes32",
                name: "",
                type: "bytes32",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address",
            },
        ],
        name: "registerAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
        ],
        name: "registerApp",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperApp",
                name: "app",
                type: "address",
            },
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
        ],
        name: "registerAppByFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "configWord",
                type: "uint256",
            },
            {
                internalType: "string",
                name: "registrationKey",
                type: "string",
            },
        ],
        name: "registerAppWithKey",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "uint256",
                name: "bitmap",
                type: "uint256",
            },
            {
                internalType: "bytes32",
                name: "agreementType",
                type: "bytes32",
            },
        ],
        name: "removeFromAgreementClassesBitmap",
        outputs: [
            {
                internalType: "uint256",
                name: "newBitmap",
                type: "uint256",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperfluidGovernance",
                name: "newGov",
                type: "address",
            },
        ],
        name: "replaceGovernance",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "bytes",
                name: "dataWithPlaceHolderCtx",
                type: "bytes",
            },
            {
                internalType: "bytes",
                name: "ctx",
                type: "bytes",
            },
        ],
        name: "testCtxFuncX",
        outputs: [
            {
                internalType: "bytes",
                name: "returnedData",
                type: "bytes",
            },
        ],
        stateMutability: "view",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperAgreement",
                name: "agreementClassLogic",
                type: "address",
            },
        ],
        name: "updateAgreementClass",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "address",
                name: "newAddress",
                type: "address",
            },
        ],
        name: "updateCode",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperTokenFactory",
                name: "newFactory",
                type: "address",
            },
        ],
        name: "updateSuperTokenFactory",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                internalType: "contract ISuperToken",
                name: "token",
                type: "address",
            },
        ],
        name: "updateSuperTokenLogic",
        outputs: [],
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [],
        name: "versionRecipient",
        outputs: [
            {
                internalType: "string",
                name: "",
                type: "string",
            },
        ],
        stateMutability: "pure",
        type: "function",
    },
];
const _bytecode = "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";
const isSuperArgs = (xs) => xs.length > 1;
class SuperfluidMock__factory extends ethers_1.ContractFactory {
    constructor(...args) {
        if (isSuperArgs(args)) {
            super(...args);
        }
        else {
            super(_abi, _bytecode, args[0]);
        }
    }
    deploy(nonUpgradable, appWhiteListingEnabled, overrides) {
        return super.deploy(nonUpgradable, appWhiteListingEnabled, overrides || {});
    }
    getDeployTransaction(nonUpgradable, appWhiteListingEnabled, overrides) {
        return super.getDeployTransaction(nonUpgradable, appWhiteListingEnabled, overrides || {});
    }
    attach(address) {
        return super.attach(address);
    }
    connect(signer) {
        return super.connect(signer);
    }
    static createInterface() {
        return new ethers_1.utils.Interface(_abi);
    }
    static connect(address, signerOrProvider) {
        return new ethers_1.Contract(address, _abi, signerOrProvider);
    }
}
exports.SuperfluidMock__factory = SuperfluidMock__factory;
SuperfluidMock__factory.bytecode = _bytecode;
SuperfluidMock__factory.abi = _abi;
//# sourceMappingURL=SuperfluidMock__factory.js.map